import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class StockAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'Stocks';

  getStockList(payload) {
    let request = {
      url: this.getAPIUrl() + '/dataStock',
      data: payload,
    };
    return httpClient.postAsync(request);
  }
}
export default new StockAPI();
